import ReportTotals from "../../Reports/ReportPage/ReportComponents/ReportTotals";
import trans from "../../../utils";

export default function IRHistoryWidgets({ data }) {
  const widgetData = [
    {
      title: "Total Reviewed",
      number: data?.totalReviewed || 0,
      type: "",
    },
    {
      title: "Approved This Period",
      number: data?.approvedThisPeriod || 0,
      type: "",
    },
    {
      title: "Rejected This Period",
      number: data?.rejectedThisPeriod || 0,
      type: "",
    },
    {
      title: "Average Review Time",
      number: data?.averageReviewTime || 0,
      type: "time",
    },
  ];

  return (
    <>
      <div className="row">
        {widgetData.map((item, index) => {
          return (
            <div className="col-lg-3 col-md-6 centered-content" key={index}>
              <ReportTotals
                title={trans(item.title)}
                number={item.number}
                type={item.type}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
